import { Component, OnInit, Signal } from '@angular/core';
import { NavController } from '@ionic/angular';
import { UserSettings, meetingDurationOptions, showAsOptions } from '../interfaces/interfaces';
import { ApiService } from '../services/api-services/api.service';
import { ToastService } from '../services/toast-service/toast.service';
import { catchError } from 'rxjs';
import { Router } from '@angular/router';
import { UserStore } from '../stores/user.store';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.page.html',
  styleUrls: ['./settings.page.scss'],
})

export class SettingsPage implements OnInit {
  showAsOptions = showAsOptions;
  userSettings: UserSettings = this.userStore.userPreferences().userSettings;
  constructor( private apiService: ApiService, private toastService: ToastService,private router :Router, private userStore: UserStore
  ) {

  }

  ngOnInit() {
   
  }




  navigateToSupport() {
    this.router.navigate(['settings/information']); 

  }

  changeStatus(event) {
    this.userStore.updateUserSettings({...this.userSettings, bookingStatus: event.target.value}).then(()=> {
      console.log('success')
    }).catch( () => {
      console.log('error')
      return this.settingsSomethingWentWrongToast()
    })
  }

  async settingsSomethingWentWrongToast() {
    await this.toastService.openErrorToastAsync('settingsSomethingWentWrongToast');
  }
}
